<template>
  <v-app>
    <v-main class="unauthorized-page">
      <v-container fluid fill-height>
        <v-row align="center" justify="center">
          <v-col cols="12">
            <div class="text-center">
              <!-- Error Code -->
              <h1 class="error-code">403</h1>

              <!-- Title with Icon -->
              <h2 class="access-title mb-3">
                Access Denied
                <span class="warning-icon">⚠️</span>
              </h2>

              <!-- Message -->
              <p class="error-message mb-8">
                <template v-if="hasNoPermissions">
                  Your account doesn't have any permissions assigned yet.
                </template>
                <template v-else>
                  You don't have permission to access this page.
                </template>
              </p>

              <!-- Actions -->
              <v-btn
                v-if="!hasNoPermissions && canGoHome"
                class="action-btn"
                large
                rounded
                elevation="0"
                @click="goToHome"
              >
                Back To Home
              </v-btn>
              <v-btn
                v-if="hasNoPermissions || !canGoHome"
                class="action-btn"
                large
                rounded
                elevation="0"
                @click="logout"
              >
                Logout
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { getDefaultRoute } from "@/router";

export default {
  name: "UnauthorizedPage",
  computed: {
    hasNoPermissions() {
      const permissions = this.$store.state.auth.permissions;
      return !permissions || permissions.length === 0;
    },
    canGoHome() {
      const defaultRoute = getDefaultRoute();
      return defaultRoute !== "UnauthorizedPage" && this.$route.name !== defaultRoute;
    },
  },
  methods: {
    goToHome() {
      const defaultRoute = getDefaultRoute();

      // Don't navigate if already on the target route
      if (defaultRoute === "UnauthorizedPage" || this.$route.name === defaultRoute) {
        return;
      }

      this.$router.push({ name: defaultRoute });
    },
    logout() {
      this.$store.dispatch("auth/logOut");
      this.$router.push({ name: "LoginPage" });
    },
  },
};
</script>

<style scoped>
.unauthorized-page {
  background: #f7fafc;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.error-code {
  font-size: 140px;
  font-weight: 700;
  color: #2d3748;
  line-height: 1;
  margin: 0;
  margin-bottom: 10px;
}

.access-title {
  font-size: 26px;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.warning-icon {
  font-size: 26px;
}

.error-message {
  font-size: 16px;
  color: #718096;
  max-width: 450px;
  margin: 0 auto;
  line-height: 1.6;
}

.action-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
  text-transform: none;
  font-weight: 500;
  font-size: 16px;
  padding: 14px 40px !important;
  box-shadow: 0 4px 6px rgba(102, 126, 234, 0.3) !important;
}

.action-btn:hover {
  box-shadow: 0 6px 12px rgba(102, 126, 234, 0.4) !important;
  transform: translateY(-1px);
}
</style>
